"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentsContainer = void 0;
var _components = require("../components");
var _contexts = require("../contexts");
var _hooks = require("../hooks");
var _jsxRuntime = require("react/jsx-runtime");
const ContentsContainer = ({
  children
}) => {
  const {
    data: contentsData
  } = (0, _hooks.useContentsQuery)();
  if (!contentsData) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Loading, {});
  }
  const {
    contents
  } = contentsData;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.ContentsProvider, {
    value: contents ?? {},
    children: children
  });
};
exports.ContentsContainer = ContentsContainer;